/**
 * Subscriptions Domain - i18n Translations
 *
 * @example
 * import { registerSubscriptionsTranslations } from 'domains/subscriptions';
 * registerSubscriptionsTranslations();
 */

import esInvoiceData from './es-MX/invoiceData.json';
import esPaymentHistory from './es-MX/paymentHistory.json';
import esSubscriptions from './es-MX/subscriptions.json';

export const subscriptionsTranslations = {
  'es-MX': esSubscriptions,
};

export const paymentHistoryTranslations = {
  'es-MX': esPaymentHistory,
};

export const invoiceDataTranslations = {
  'es-MX': esInvoiceData,
};

export { registerSubscriptionsTranslations, areSubscriptionsTranslationsLoaded } from './registerTranslations';
